import { Badge, Theme } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledBadge = withStyles(theme => ({
  dot: {
    border: '2px solid white',
    borderRadius: '50%',
    boxSizing: 'border-box',
    minWidth: '0.6875rem',
    height: '0.6875rem'
  },

  anchorOriginBottomRightCircular: {
    right: '16%',
    bottom: '16%'
  }
}))(Badge)

interface UserInfoStylesProps {
  online: string
}

const useStyles = makeStyles<Theme, UserInfoStylesProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    minWidth: '170px',
    height: '40px',
    paddingLeft: '0.375rem',
    paddingRight: '0.705rem',
    backgroundColor: '#E4E8EA',

    '& .MuiBadge-dot': {
      backgroundColor: ({ online }) =>
        online === 'online' ? '#2abb88' : theme.palette.away
    }
  },

  newVersionRoot: {
    minWidth: 'unset',
    paddingLeft: '0',
    paddingRight: '0',
    backgroundColor: 'transparent'
  },

  avatar: {
    width: '35px',
    height: '35px'
  },

  newVersionAvatar: {
    marginRight: '8px',
    width: '40px',
    height: '40px'
  },

  nameBlock: {
    flex: '1 1 auto',
    marginLeft: '1rem',
    opacity: '0.8',
    color: 'black',

    [theme.breakpoints.down('lg')]: {
      marginLeft: '0.5rem'
    },

    '& .name': {
      overflow: 'hidden',
      marginBottom: '0.125rem',
      maxWidth: '152px',
      fontSize: theme.size.sm,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },

    '& .time': {
      fontSize: theme.size.sm
    }
  },

  icon: {
    cursor: 'pointer',
    fontSize: theme.size.lg,
    color: theme.palette.primary.main
  },

  dividerTop: {
    borderTop: '1px solid black',
    width: '100%',
    paddingTop: '8px'
  },

  dividerBottom: {
    borderBottom: '1px solid black',
    width: '100%',
    paddingBottom: '8px'
  }
}))

export default useStyles
